import Commons from '../../../Services/Common/Common';

/**
 * 작업후기 작성 (M_WOE_BASIC_02) 요청 파라미터 매핑
 * 사용처: M_WOE_BASIC_02_Query.js (useSearch1, useSave1)
 */
export const WOE_BASIC_02_Schema = {
  /** 화면 폼 필드 정의 (initial, label, required, placeholder, maxLength) - createInitial / InputText schema 참조 */
  fields: {
    afterComment: {
      initial: '',
      label: '내용',
      required: 'Y',
      placeholder: '내용을 입력하세요.',
      maxLength: 1000,
    },
  },

  mapper: {
    /** useSearch1 → GetWoeBasicR3 (작업후기 상세 조회) SP_WOE_BASIC_R2 */
    search1: {
      WorkCd: (context) =>
        Commons.EncryptAES(context.workCd ?? '') || '',
    },
    /** useSave1 → SaveWoeBasicU3 (작업후기 저장) SP_WOE_BASIC_U2 */
    save1: {
      WorkCd: (ctx) => Commons.EncryptAES(ctx?.workCd ?? '') || '',
      AfterComment: (ctx) =>
        Commons.EncryptAES(ctx?.afterComment ?? '') || '',
      AfterImage: (ctx) =>
        Commons.EncryptAES(ctx?.afterImage ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
  },
};
